import { useEffect } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { useTracker } from 'setup-guide-components/hooks/tracking';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UsageLimitPopover = ({
  children,
  description,
  onClose,
  open,
  placement = 'bottom',
  planLimitLabel,
  planUsageLabel,
  taskKey,
  title,
  upgradeCta,
  upgradeKey,
  usageCurrent = 0,
  usageLimit = 0,
  width = 400
}) => {
  const {
    trackSectionView,
    trackTaskInteraction
  } = useTracker();
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeKey);
  useEffect(() => {
    if (open) {
      trackSectionView('usage limit popover', taskKey);
    }
  }, [open, trackSectionView, taskKey]);
  const UsageLimitPopoverHeader = () => /*#__PURE__*/_jsx(Text, {
    as: "h5",
    marginBlockEnd: "300",
    children: title
  });
  const UsageLimitPopoverBody = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      marginBlockEnd: "200",
      typography: "detail-100",
      use: "help",
      children: description
    }), /*#__PURE__*/_jsx(Progress, {
      descriptiveLabel: /*#__PURE__*/_jsx(Text, {
        margin: "0",
        typography: "heading-25",
        children: planLimitLabel
      }),
      max: usageLimit,
      use: "warning",
      value: usageCurrent,
      valueLabel: /*#__PURE__*/_jsx(Text, {
        typography: "heading-25",
        use: "help",
        children: planUsageLabel
      })
    })]
  });
  const UsageLimitPopoverFooter = () => /*#__PURE__*/_jsx(Text, {
    typography: "heading-25",
    children: /*#__PURE__*/_jsx(Link, {
      external: true,
      onClick: () => {
        trackTaskInteraction('click usage limit popover upgrade cta', taskKey);
        openUpgradeModal();
      },
      children: upgradeCta
    })
  });
  const UsageLimitPopoverContent = () => /*#__PURE__*/_jsxs(View, {
    paddingBlock: "500",
    paddingInline: "600",
    children: [/*#__PURE__*/_jsx(UsageLimitPopoverHeader, {}), /*#__PURE__*/_jsx(UsageLimitPopoverBody, {}), /*#__PURE__*/_jsx(UsageLimitPopoverFooter, {})]
  });
  return /*#__PURE__*/_jsx(Popover, {
    Content: UsageLimitPopoverContent,
    closeOnOutsideClick: true,
    closeOnTargetLeave: true,
    maxInlineSize: `${width}px`,
    onOpenChange: isOpen => {
      if (!isOpen.currentTarget.value) {
        onClose === null || onClose === void 0 || onClose();
      }
    },
    open: open,
    placement: placement,
    children: children
  });
};
export default UsageLimitPopover;